const steps = [
  { step: '01', icon: 'ri-search-line', title: 'Znajdź produkt', desc: 'Przeglądaj kategorie i znajdź interesujący Cię produkt w Kakobuy Spreadsheet.' },
  { step: '02', icon: 'ri-file-list-3-line', title: 'Sprawdź informacje', desc: 'Zapoznaj się ze szczegółami – ceną, opisem, zdjęciami QC i opiniami innych kupujących.' },
  { step: '03', icon: 'ri-shield-check-line', title: 'Zweryfikuj jakość', desc: 'Upewnij się, że produkt spełnia Twoje oczekiwania, sprawdzając oceny sprzedawcy i autentyczność.' },
  { step: '04', icon: 'ri-shopping-bag-3-line', title: 'Przejdź do zakupu', desc: 'Kliknij w link i przejdź do zakupu na sprawdzonej platformie z pełnym bezpieczeństwem.' },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            Jak to działa
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Jak korzystać z Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Cztery proste kroki, które dzielą Cię od znalezienia idealnego produktu i bezpiecznego zakupu.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((item, i) => (
            <div key={i} className="relative group">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all h-full">
                <span className="font-heading text-4xl font-bold text-primary-100 group-hover:text-primary-200 transition-colors">
                  {item.step}
                </span>
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-white my-4">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-foreground-300 z-10">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}